export const schema = {
  emailAddress: {
    presence: { allowEmpty: true },
    email: true,
    length: {
      maximum: 300,
    },
  },
};